import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface CompletionStats {
  completionDate: Date;
  totalTimeSpent?: string;
  classesCompleted: number;
  totalClasses: number;
}

@Component({
  selector: 'app-course-completion-modal',
  templateUrl: './course-completion-modal.component.html',
  styleUrls: ['./course-completion-modal.component.css']
})
export class CourseCompletionModalComponent {
  @Input() stats: CompletionStats;

  constructor(public activeModal: NgbActiveModal) { }

  goToCertificate(): void {
    this.activeModal.close('certificate');
  }

  close(): void {
    this.activeModal.close();
  }
}
